import { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const ThemeWrapper = ({ children }) => {
  const [theme] = useState(createTheme({}));
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeWrapper;
